var _defs, _g, _polygon, _path, _polygon2, _polygon3, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirconditioning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f07662;}.cls-2{fill:#e5e5e5;}.cls-3{fill:#e4e7ef;}.cls-4{fill:#666;}.cls-5{fill:#ccc;}.cls-6{fill:#41939e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Axa.be-Fixico-_-Homecare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m88,94l-6.36-48.47L18.78,13.95V0L5,7.03v37.09c0,4.87,1.8,8.99,4.99,10.83v.05s78.01,39,78.01,39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-3",
    points: "95.42 38.5 18.69 0 5 7.03 81.64 45.53 95.42 38.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-2",
    d: "m81.64,78.1v-32.57s13.78-7.03,13.78-7.03v54.54c-2.48,1.42-5.13,1.85-7.55.99-3.97-1.41-6.23-5.94-6.23-11.41v-4.52Z"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "73 48 73 53.5 10.57 21.36 10.57 16.36 73 48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-4",
    d: "m78.87,89.5c-3.87-2.5-6.23-6.41-6.23-11.88L10.64,46.62c0,5.46,2.27,10.47,6.23,11.88l62,31Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "74.39 83.88 11 52 12.25 54.1 76 86.34 74.39 83.88"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "75 81 8 47.36 8 48.76 74 82 75 81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.41,59.77s-7.66,2.21-4.53,6.72-8.88,7.51-8.88,7.51c0,0,2,1.39,2,2.19s11.47-4.23,10.24-8.21,3.76-6.98,3.76-6.98l-2.59-1.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.41,81.77s-7.66,2.21-4.53,6.72-8.88,7.51-8.88,7.51c0,0,2,1.39,2,2.19s11.47-4.23,10.24-8.21,3.76-6.98,3.76-6.98l-2.59-1.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.41,70.3s-7.66,2.21-4.53,6.72-8.88,7.51-8.88,7.51c0,0,2,1.39,2,2.19s11.47-4.23,10.24-8.21,3.76-6.98,3.76-6.98l-2.59-1.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirconditioning);
export default __webpack_public_path__ + "static/media/airconditioning.8aad0c8b893d0127032f9395c8f1332f.svg";
export { ForwardRef as ReactComponent };